import { AxiosResponse } from 'axios';
import HttpClientWithRetry from '../../../../../http/client/HttpClientWithRetry';
import {
  BusinessLocationsResponse,
  FetchRecruiterResponseT,
  LocationFilterQuery,
  PositionAddressResponse,
  PositionResponse,
  FollowStateEnum,
} from '../types';

export class MonitorByRecruitersController {
  constructor(private readonly httpClient: HttpClientWithRetry) {}

  fetchRecruiters(accountId: string): Promise<AxiosResponse<FetchRecruiterResponseT>> {
    const path = `/api/v1/account/${accountId}/recruiters`;
    return this.httpClient.get<FetchRecruiterResponseT>(path);
  }

  fetchRecruitersWithOperator(accountId: string): Promise<AxiosResponse<FetchRecruiterResponseT>> {
    const path = `/api/v1/account/${accountId}/recruitersWithOperator`;
    return this.httpClient.get<FetchRecruiterResponseT>(path);
  }

  fetchBusinessAddress(): Promise<AxiosResponse<PositionAddressResponse>> {
    const path = '/api/v1/business/getBusinessAddressDetails';
    return this.httpClient.get<PositionAddressResponse>(path);
  }

  fetchPosition(accountId: string, positionFilters: Record<string, unknown>): Promise<AxiosResponse<PositionResponse>> {
    const path = `/api/v1/account/${accountId}/filterPositions`;
    return this.httpClient.post<PositionResponse>(path, positionFilters);
  }

  fetchLocations(params: LocationFilterQuery): Promise<AxiosResponse<BusinessLocationsResponse>> {
    const path = '/api/v5/businesses';
    return this.httpClient.get<BusinessLocationsResponse>(path, { params });
  }

  fetchJobs(accountId: string): Promise<AxiosResponse<{ jobs: Record<string, 'open' | 'closed' | 'archived'> }>> {
    const path = `/api/v1/account/${accountId}/jobs`;
    return this.httpClient.get<{ jobs: Record<string, 'open' | 'closed' | 'archived'> }>(path);
  }

  updatePositionStatusOfRecruiter({
    positionId,
    recruiterId,
    status,
  }: {
    positionId: string;
    recruiterId: string;
    status: string;
  }): Promise<AxiosResponse> {
    const path = `/api/v1/position/${positionId}/assignedRecruiterBasedOnOperationStatus`;
    return this.httpClient.post(path, { followedStatus: status, recruiterId });
  }

  bulkUpdate({
    accountId,
    positionDetails,
    recruiterIds,
    followedStatus,

    businessIds,
    city,
    jobCustomNames,
    positionStatus,
    province,
    archived,
  }: {
    accountId: string;
    positionDetails: {
      positionId: string;
      businessId: string;
    }[];
    recruiterIds: string[];
    followedStatus: FollowStateEnum;

    businessIds?: string[];
    city?: string[];
    jobCustomNames?: string[];
    positionStatus?: string[];
    province?: string[];
    archived?: boolean;
  }): Promise<AxiosResponse> {
    const path = `/api/v1/account/${accountId}/bulkAssignPositions`;
    return this.httpClient.post(path, {
      followedStatus,
      recruiterIds,
      positionDetails,
      businessIds,
      city,
      jobCustomNames,
      positionStatus,
      province,
      archived,
    });
  }
}
